export const GET_STAKEHOLDER_PROGRESS =
  'pages/member/dashboard/stakeholder/progress-check'
